import React, { useMemo } from 'react';
import Button from 'components/shared/app/Button';
import DateRangePicker from 'components/shared/app/DateRangePicker';
import Dropdown from 'components/shared/app/Dropdown';
import { allMetricOptions, allPerformanceOptions, highLowPerformanceOptions } from './config';

function LPManagerHeader({
    metricOption,
    performanceOption,
    dateRange,
    onMetricOptionChange,
    onPerformanceOptionChange,
    onDateRangeChange,
    onRefresh
}) {
    const metricOptionLabel = useMemo(() => allMetricOptions.find(o => o.value == metricOption).label, [metricOption]);
    const performanceOptionLabel = useMemo(() => allPerformanceOptions.find(o => o.value == performanceOption).label, [performanceOption]);
    const performanceOptions = useMemo(() => {
        return ['Adspend', 'Revenue', 'Profit', 'Conv Rate', 'Orders'].includes(metricOption) ? highLowPerformanceOptions : allPerformanceOptions
    }, [metricOption]);

    function handleMetricOptionChange(value) {
        onMetricOptionChange(value);
        onPerformanceOptionChange('Highest');
    }

    return (
        <div className="page-header">
            <div className="filter">
                <Dropdown className="white"
                    selectedItem={metricOptionLabel}
                    setSelection={handleMetricOptionChange}
                    items={allMetricOptions}
                />
                is
                <Dropdown className="white"
                    selectedItem={performanceOptionLabel}
                    setSelection={onPerformanceOptionChange}
                    items={performanceOptions}
                />
                for

                <DateRangePicker dateRange={dateRange} onSetDateRange={onDateRangeChange} />

                <Button className="btn-view-event" round color="white" onClick={onRefresh}>Refresh</Button>
            </div>
        </div>
    );
}

export default LPManagerHeader;